// extracted by css-extract-rspack-plugin
export default {"AliceExternalAppJsonEditor":"AliceExternalAppJsonEditor__XtZMF","AliceExternalAppJsonEditor_error":"AliceExternalAppJsonEditor_error__DNi_y"};